import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactGA from 'react-ga';
import Helmet from 'react-helmet';
import { Element } from 'react-scroll';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { ga, production } from '../config';
import '../polyfills';
import { sanitizeContent, scrollToElement } from '../utils';
import './index.css';
import './loader.css';
import './reset.css';




class Layout extends Component {
  componentDidMount() {
    const { hash, pathname, search } = this.props.location;
    if (production) {
      ReactGA.initialize(ga);
      // disable console.log
      console.log = () => {};
      // disable console.info
      console.info = () => {};
      const page = `${pathname}${search}`;
      ReactGA.set({ page, anonymizeIp: true });
      ReactGA.pageview(page);
    }
    if (pathname === '/') {
      setTimeout(() => scrollToElement(hash.replace('#', '')), 100);
      history.pushState('', document.title, window.location.pathname + window.location.search);
    }
    const loader = document.getElementById('loader');
    if (loader) loader.outerHTML = '';
  }

  renderHelmet = () => {
    const {
      location: { pathname },
      layoutContext: {
        company: { website, name: companyName },
        config: { title, routes },
      },
    } = this.props;

    try {
      const {
        meta: { description },
      } = routes.find(({ path }) => path === pathname);
      return (
        <Helmet>
          <title itemProp="name">{title}</title>
          <meta name="description" content={`${companyName} - ${description}`} />
          <link key="meta-x-default" rel="alternate" hreflang="x-default" href={`${website}${pathname}`} />
        </Helmet>
      );
    } catch (error) {
      return <Helmet title={title} />;
    }
  };

  render() {
    const {
      location,
      children,
      layoutContext: {
        subparts,
        company,
        companies,
        config: { routes, categories, keys, domain, endpoint },
      },
    } = this.props;

    const { name: webdesigner, website } = companies.find(({ name }) => name.toLowerCase().includes('hinterland'));

    return (
      <div>
        {this.renderHelmet()}
        <Header routes={routes} categories={categories} {...location} company={company} />
        <div>{children()}</div>
        <Element name="kontakt">
          <Contact
            company={company}
            contactFormConfig={{ domain, endpoint }}
            apiKey={keys.find(({ name }) => name === 'googlemaps')}
            {...sanitizeContent(subparts, 'dataprivacy', 'dataprocessing')}
          />
          <Footer webdesigner={webdesigner} website={website} />
        </Element>
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.func,
  layoutContext: PropTypes.shape({
    subparts: PropTypes.array.isRequired,
    config: PropTypes.object.isRequired,
    company: PropTypes.shape({
      addressFields: PropTypes.arrayOf(PropTypes.string),
      address: PropTypes.string,
      name: PropTypes.string,
      ceo: PropTypes.string,
      mobile: PropTypes.string,
      mail: PropTypes.string,
      phone: PropTypes.string,
      coordinates: PropTypes.shape({ lat: PropTypes.number.isRequired, lon: PropTypes.number.isRequired }),
    }).isRequired,
  }),
};

export default Layout;



// WEBPACK FOOTER //
// ./src/templates/layout.index.js